import { Validators } from '@angular/forms';
import { Formulario } from './../interface/fomulario';

export class Telefono implements Formulario {
    createFormulario(): any[] {
        const form = [{element: 'number', name: 'phone2', label: 'Teléfono secundario*',
         validations: [Validators.required, Validators.minLength(9), Validators.maxLength(9)]}
    ];
        return form;
    }
}
